import React from "react";
import firebase from "../../firebase";
import { connect } from "react-redux";
import { setCurrentChannel, setPrivateChannel } from "../../actions";
import moment from "moment";
import ReadMoreReact from "read-more-react";
import { Editor } from "@tinymce/tinymce-react";
import Parser from "html-react-parser";
import {
  Card,
  Image,
  Header,
  Icon,
  Modal,
  Form,
  Input,
  Button,
  Label,
  TextArea,
  Grid,
  Radio,
  Divider,
  Container,
  Segment,
  Popup,
} from "semantic-ui-react";
import Anonymousimage from "./../../anonymous.png";
import { withRouter } from "react-router-dom";
import InputTags from "./InputTags.js";
import ChannelTypesInfo from "./ChannelTypesInfo";
import { ROUTES_NAMES } from "../../routes";
import ReportDropdown from "./ReportDropdown";
import CloudsLikeButton from "./CloudsLikeButton";
import ConnectUserOnClick from "../MetaPanel/ConnectUserOnClick";
import ArticleTypesInfo from "./ArticleTypesInfo";
import MediaQuery from "react-responsive";

let CLOUD_ADD_SCORE = 10;

class Clouds extends React.Component {
  state = {
    activeChannel: "",
    user: this.props.currentUser,
    channel: null,
    channels: [],
    channelType: "",
    channelName: "A cloud",
    channelDetails: "",
    channelTags: [],
    privateChannel: false,
    anonymousChannel: false,
    channelsRef: firebase.database().ref("channels"),
    messagesRef: firebase.database().ref("messages"),
    typingRef: firebase.database().ref("typing"),
    usersRef: firebase.database().ref("users"),
    notifications: [],
    contentModal: false,
    typeModal: false,
    firstLoad: true,
    admin: this.props.admin && this.props.admin === true ? true : false,
    matches: window.matchMedia("(min-width: 900px)"),
    userContributions: 0,
    searchTerm: "",
    searchLoading: false,
    searchResults: [],
  };

  componentDidMount() {
    if (this.state.user) {
      setTimeout(() => this.addListeners(this.state.user.uid), 0);
    }
    const handler = (e) => this.setState({ matches: e.matches });
  }

  componentWillUnmount() {
    this.removeListener();
    console.log(this.props.bookmarkedClouds);
  }

  removeListener = () => {
    this.getCloudsRef().off();
    if (this.state.bookmarkedClouds) {
      this.state.channelsRef.off();
    }
    this.state.usersRef.child(this.state.user.uid).child("contributions").off();
    this.state.usersRef.child(this.state.user.uid).off();
  };

  getCloudsRef = () => {
    return this.props.bookmarkedClouds
      ? this.state.usersRef.child(`${this.state.user.uid}/starred`)
      : this.state.channelsRef;
  };

  addListeners = (userId) => {
    this.getCloudsRef().on("child_added", (snap) => {
      const starredChannel = { id: snap.key, ...snap.val() };
      this.setState({
        channels: [starredChannel, ...this.state.channels],
      });
    });

    this.getCloudsRef().on("child_removed", (snap) => {
      const channelToRemove = { id: snap.key, ...snap.val() };
      const filteredChannels = this.state.channels.filter((channel) => {
        return channel.id !== channelToRemove.id;
      });
      this.setState({ channels: filteredChannels });
    });

    this.state.channelsRef.on("child_changed", (snap) => {
      let updatedCloud = snap.val();
      let updatedCloudsList = [...this.state.channels];
      let ind = updatedCloudsList.findIndex(
        (cld) => cld.id === updatedCloud.id
      );
      updatedCloudsList[ind] = updatedCloud;
      this.setState({ channels: updatedCloudsList });
    });

    let currentContext = this;
    this.state.usersRef
      .child(this.state.user.uid)
      .child("contributions")
      .once("value")
      .then(function (snapshot) {
        let loadedContrib = snapshot.val(); // "ada"
        let userContributions = loadedContrib === null ? 0 : loadedContrib;
        currentContext.setState({ userContributions: userContributions });
      });
    this.state.usersRef
      .child(this.state.user.uid)
      .on("child_changed", (snap) => {
        let updatedValue = snap.val();
        if (!isNaN(updatedValue))
          this.setState({ userContributions: updatedValue });
      });
  };

  setActiveChannel = (channel) => {
    this.setState({ activeChannel: channel.id });
  };

  changeChannel = (channel) => {
    this.setActiveChannel(channel);
    this.props.setCurrentChannel(channel);
    this.props.setPrivateChannel(false);
  };

  cloudOnClick = (channel) => {
    this.changeChannel(channel);
    this.props.history.push(ROUTES_NAMES.app);
  };

  handleSearchChange = (event) => {
    this.setState(
      {
        searchTerm: event.target.value,
        searchLoading: true,
      },
      () => this.handleSearchChannels()
    );
  };

  handleSearchChannels = () => {
    const channelsCopy = [...this.state.channels];
    const regex = new RegExp(this.state.searchTerm, "gi");
    const searchResults = channelsCopy.reduce((acc, channel) => {
      let channelCreatorBoolean =
        channel.createdBy.name.match(regex) && !channel.anonymous;
      let channelTagsBoolean = channel.tags.some((tag) =>
        tag.text.match(regex)
      );
      if (
        channel &&
        (channel.details.match(regex) ||
          channelCreatorBoolean ||
          channelTagsBoolean)
      ) {
        acc.push(channel);
      }
      return acc;
    }, []);
    this.setState({ searchResults });
    setTimeout(() => this.setState({ searchLoading: false }), 1000);
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.isFormValid(this.state)) {
      this.addChannel();
      this.updateUserContributions();
    }
  };

  handleChange = (event) => {
    if (event.target.type === "radio") {
      this.handleInputToggle(event);
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  handleEditorChange = (content) => {
    this.setState({ channelDetails: content });
  };

  handleInputToggle = (event) => {
    console.log(event.target.name);
    if (event.target.name === "privateChannel")
      this.setState({ privateChannel: !this.state.privateChannel });
    else this.setState({ anonymousChannel: !this.state.anonymousChannel });
  };

  addChannel = () => {
    const {
      channelsRef,
      channelName,
      channelType,
      channelDetails,
      channelTags,
      privateChannel,
      anonymousChannel,
      user,
    } = this.state;

    const key = channelsRef.push().key;

    const newChannel = {
      id: key,
      type: channelType,
      name: channelName,
      details: channelDetails,
      tags: channelTags,
      private: privateChannel,
      anonymous: anonymousChannel,
      reported: false,
      createdBy: {
        name: user.displayName,
        avatar: user.photoURL,
        userId: user.uid,
        id: user.uid,
      },
      likes: 0,

      timestamp: firebase.database.ServerValue.TIMESTAMP,
    };

    channelsRef
      .child(key)
      .update(newChannel)
      .then(() => {
        this.setState({ channelName: "", channelDetails: "", channelType: "" });
        this.closeModal();
        console.log("channel added");
      })
      .catch((err) => {
        console.error(err);
      });
  };

  updateUserContributions() {
    let currentVal = this.state.userContributions;
    let valToPush = { contributions: currentVal + CLOUD_ADD_SCORE };
    this.state.usersRef
      .child(this.state.user.uid)
      .update(valToPush)
      .then(() => {
        this.setState({ userContributions: currentVal + CLOUD_ADD_SCORE });
        console.log("User contribution updated");
      })
      .catch((err) => {
        console.error(err);
      });
  }

  displayChannelTypes = (channels) =>
    channels.length > 0 &&
    channels.map((chn, ind) => (
      <Grid.Row key={ind} centered="true">
        <Button
          color={chn.color}
          inverted
          onClick={() => this.toggleModal(ind)}
          size="large"
          style={{ width: "50%" }}
        >
          <h1>{chn.name}</h1>
          <h5>{chn.description}</h5>
        </Button>
      </Grid.Row>
    ));

  isFormValid = ({ channelDetails, channelTags }) =>
    channelDetails && channelTags.length > 0;

  openModal = () => this.setState({ typeModal: true, contentModal: false });

  toggleModal(ind) {
    this.setState({
      typeModal: false,
      contentModal: true,
      channelType: ChannelTypesInfo[ind].name,
    });
  }

  closeModal = () => this.setState({ typeModal: false, contentModal: false });

  timeFromNow = (timestamp) => moment(timestamp).fromNow();

  displayTags = (tags) =>
    tags.map((tag) => (
      <Label key={tag.id} text={tag.text} image>
        {tag.text}
        <Icon name="delete" />
      </Label>
    ));

  tagsOnClick = (text) => console.log(text);

  channelSortDefinition(channel1, channel2) {
    let moment1 = moment(channel1.timestamp);
    let moment2 = moment(channel2.timestamp);
    if (moment1.isBefore(moment2)) return 1;
    else if (moment2.isBefore(moment1)) return -1;
    else return 0;
  }

  getCloudsToDisplay() {
    let usersToDisplay = this.state.searchTerm
      ? this.state.searchResults
      : this.state.channels;

    let sortedChannels = usersToDisplay.sort(this.channelSortDefinition);
    return this.state.admin
      ? sortedChannels.filter((ch) => ch.reported)
      : sortedChannels;
  }

  displayClouds = (channels) =>
    channels.length > 0 &&
    channels.map((channel) => (
      <Card
        color="blue"
        style={{ height: 230, overflowY: "hidden", overflowX: "visible" }}
        fluid
        key={channel.id}
        name={channel.name}
        createdBy={channel.createdBy}
        active={channel.id === this.state.activeChannel}
        type={channel.type}
      >
        <Card.Content>
          <div>
            <div>
              {channel.anonymous ? (
                <Image
                  floated="left"
                  circular
                  size="mini"
                  src={Anonymousimage}
                />
              ) : (
                <Image
                  floated="left"
                  circular
                  size="mini"
                  src={channel.createdBy.avatar}
                />
              )}
            </div>

            <div>
              <Card.Header>
                <a>
                  <strong
                    style={{ fontSize: 15, color: "black", opacity: 0.9 }}
                  >
                    {channel.anonymous ? (
                      "Anonymous "
                    ) : (
                      channel.createdBy.id === this.state.user.uid ? channel.createdBy.name :
                      <ConnectUserOnClick user={channel.createdBy} />
                    )}
                  </strong>
                </a>
              </Card.Header>

              <span style={{ float: "right" }}>
                <Icon name="flag" />
                <ReportDropdown
                  user={this.state.user}
                  channel={channel}
                  admin={this.state.admin}
                />
              </span>
            </div>
            <Card.Meta>{this.timeFromNow(channel.timestamp)}</Card.Meta>
            <Divider />
          </div>

          <a>
            <Card.Description
              style={{
                flex: 1,
                flexWrap: "wrap",
                color: "black",
                opacity: "0.9",
                fontSize: "14px",
                height: 80,
                overflowY: "hidden",
              }}
              onClick={() => this.cloudOnClick(channel)}
            >
              {/* <div>{channel.details}</div> */}
              <td>{Parser(channel.details)}</td>
              {/* <ReadMoreReact
                text={channel.details}
                min={140}
                ideal={150}
                max={160}
                readMoreText={
                  <strong style={{ color: "#0fabbc" }}>Read</strong>
                }
              /> */}
            </Card.Description>
          </a>
        </Card.Content>
        <Card.Content extra>
          <div style={{ float: "left" }}>
            {channel.tags &&
              channel.tags.map((tag) => (
                <Label
                  color="blue"
                  style={{ opacity: 0.8 }}
                  onClick={() => this.tagsOnClick(tag.text)}
                >
                  {" "}
                  {tag.text}
                </Label>
              ))}
          </div>
          <div style={{ float: "right" }}>
            <CloudsLikeButton cloud={channel} />
          </div>
        </Card.Content>
      </Card>
    ));

  render() {
    const { channels, contentModal, typeModal } = this.state;

    return (
      <React.Fragment>
        <Header as="h2">
          <span>
            <React.Fragment>
              <Icon name="exchange" color="black" />{" "}
              {this.state.admin
                ? "Reported Clouds"
                : this.props.bookmarkedClouds
                ? "Bookmarked Clouds"
                : "Clouds"}{" "}
              ({this.getCloudsToDisplay().length}){" "}
              {this.state.admin ? null : (
                <Button
                  style={{
                    marginLeft: 10,
                    backgroundColor: "#16AB39",
                    opacity: 0.8,
                  }}
                  onClick={this.openModal}
                  primary
                >
                  <Icon name="add" />
                  Add Cloud{" "}
                </Button>
              )}
              <Input
                style={{ verticalAlign: "center" }}
                size="mini"
                loading={this.state.searchLoading}
                onChange={this.handleSearchChange}
                icon="search"
                name="searchTerm"
                placeholder="Search Clouds"
                value={this.state.searchTerm}
              />
            </React.Fragment>
          </span>
        </Header>

        <div>
          <MediaQuery minDeviceWidth={1224}>
            <Card.Group itemsPerRow={3}>
              {this.displayClouds(this.getCloudsToDisplay())}
            </Card.Group>
          </MediaQuery>
          <MediaQuery maxDeviceWidth={1224}>
            <Card.Group itemsPerRow={1}>
              {this.displayClouds(this.getCloudsToDisplay())}
            </Card.Group>
          </MediaQuery>
        </div>

        {/* <Card.Group itemsPerRow={3}>
          {this.displayClouds(this.getCloudsToDisplay())}
        </Card.Group> */}

        {/* Add Channel Content Modal */}
        <Modal basic open={contentModal} onClose={this.closeModal}>
          <Header as="h2">Add a cloud</Header>
          <Modal.Content>
            <Form onSubmit={this.handleSubmit}>
              <Form.Field></Form.Field>
              <Form.Field>
                <Editor
                  value={this.state.channelDetails}
                  initialValue="<p>This is the initial content of the editor</p>"
                  init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                      "advlist autolink lists link charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime paste help wordcount",
                    ],
                    toolbar:
                      "undo redo | formatselect | bold italic backcolor | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | removeformat | help",
                  }}
                  onEditorChange={this.handleEditorChange}
                />
                {/* <TextArea
                  style={{ height: 300 }}
                  fluid
                  placeholder="Write your heart out!!"
                  name="channelDetails"
                  onChange={this.handleChange}
                /> */}
              </Form.Field>
              <span>
                <div>
                  {/* <Form.Field>
                    <label style={{ color: "white" }}>
                      <input
                        style={{ margin: "10px" }}
                        type="radio"
                        name="privateChannel"
                        checked={this.state.privateChannel}
                        onClick={this.handleChange}
                      />
                      Make this Cloud Private
                    </label>
                  </Form.Field> */}
                </div>
                <div>
                  <Form.Field>
                    <label style={{ color: "white" }}>
                      <input
                        style={{ margin: "10px" }}
                        type="radio"
                        name="anonymousChannel"
                        checked={this.state.anonymousChannel}
                        onClick={this.handleChange}
                      />
                      Post this cloud as anonymous
                    </label>
                  </Form.Field>
                </div>
              </span>
              <Form.Field>
                <label style={{ color: "white" }}>
                  <InputTags
                    tags={(val) => this.setState({ channelTags: val })}
                  />
                  Input tags for eg. love, IIT Delhi etc
                </label>
              </Form.Field>
            </Form>
          </Modal.Content>

          <Modal.Actions>
            <Button color="green" inverted onClick={this.handleSubmit}>
              Add
            </Button>
            <Button color="red" inverted onClick={this.closeModal}>
              Cancel
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic open={typeModal} onClose={this.closeModal}>
          <Modal.Actions>
            <Grid centred="true">
              {this.displayChannelTypes(ChannelTypesInfo)}
            </Grid>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  currentChannel: state.channel.currentChannel,
  isPrivateChannel: state.channel.isPrivateChannel,
  userPosts: state.channel.userPosts,
  primaryColor: state.colors.primaryColor,
  secondaryColor: state.colors.secondaryColor,
});

export default withRouter(
  connect(mapStateToProps, { setCurrentChannel, setPrivateChannel })(Clouds)
);



// WEBPACK FOOTER //
// ./src/components/SidePanel/Clouds.js